import {
  Box,
  Button,
  FormControlLabel,
  Popover,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { EPalletType, EProductType } from "model";
import React from "react";
import { PALLET_TYPE, PRODUCT_TYPE } from "common";
import { StringHelper } from "helpers";
import { I18nTranslator, translations } from "utils/i18n";
import { DatePicker } from "@mui/lab";

interface IFilterPopupProps {
  currentType?: EPalletType;
  anchor: HTMLButtonElement | null;
  onClose(): void;
  onSave(value?: EPalletType): void;
}

enum EQuantityType {
  ALL = "A",
  EMPTY = "EM",
  EXIST = "EX",
}

export const QUANTITY_TYPE = [
  {
    type: EQuantityType.ALL,
    name: translations.type.allType,
  },
  {
    type: EQuantityType.EMPTY,
    name: translations.type.empty,
  },
  {
    type: EQuantityType.EXIST,
    name: translations.type.exists,
  },
];

const FilterPopup = (props: IFilterPopupProps) => {
  const { anchor, currentType, onClose, onSave } = props;
  const open = Boolean(anchor);
  const [value, setValue] = React.useState<EPalletType | undefined>(
    currentType
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value as EPalletType);
  };
  const handleSave = () => {
    onSave(value);
    onClose();
  };
  return (
    <Popover
      id={"filter"}
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ width: 500 }} p={2}>
        <Typography fontWeight={"bold"} variant={"h3"}>
          {I18nTranslator(translations.masterData.filter)}
        </Typography>
        <Box sx={{}}>
          <Box sx={{ marginBottom: "20px", marginTop: "20px" }}>
            <Typography fontWeight={"bold"} variant={"h4"}>
              {I18nTranslator(translations.masterData.productType)}
            </Typography>
            <RadioGroup
              defaultValue={value}
              style={{ display: "flex", flexDirection: "row" }}
            >
              {PALLET_TYPE.map((type) => {
                return (
                  <FormControlLabel
                    key={type.name}
                    control={<Radio onChange={handleChange} />}
                    label={StringHelper.getPalletTypeName(type.type)}
                    value={type.type}
                  />
                );
              })}
            </RadioGroup>
          </Box>
          {/* <Box sx={{ marginBottom: "20px" }}>
              <Typography fontWeight={"bold"} variant={"h4"}>
                Tình trạng hàng hóa
              </Typography>
              <RadioGroup
                defaultValue={value}
                style={{ display: "flex", flexDirection: "row" }}
              >
                {QUANTITY_TYPE.map((type) => {
                  return (
                    <FormControlLabel
                      key={type.name}
                      control={<Radio onChange={handleChange} />}
                      label={I18nTranslator(type.name)}
                      value={type.type}
                    />
                  );
                })}
              </RadioGroup>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <Typography fontWeight={"bold"} variant={"h4"}>
                Ngày bắt đầu sử dụng
              </Typography>
              <DatePicker
                value={"10-10-2022"}
                onChange={() => {}}
                renderInput={(params) => (
                  <TextField {...params} sx={{ paddingTop: "10px" }} />
                )}
              />
            </Box> */}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" onClick={handleSave}>
            {I18nTranslator(translations.button.save)}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default FilterPopup;
